<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Message.PleaseSelect')"
    width="750px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="imdgCodes"
      style="width:100%;height:300px"
      @gridReady="params=>gridApi=params.api"
    />
    <span slot="footer">
      <el-button type="primary" @click="saveHandler">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('SeaExport.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: 'ImdgCodeSelectDialog',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    imdgCodes: { type: Array, required: false }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: 'UN No.',
          field: 'unNo',
          width: 120
        },
        {
          headerName: 'PSN',
          field: 'psn',
          width: 100
        },
        {
          headerName: 'Class',
          field: 'classification',
          width: 100
        },
        {
          headerName: 'Packing Group',
          field: 'packingGroup',
          width: 100
        },
        {
          headerName: 'Limited Quantities',
          field: 'limitedQuantities',
          width: 100
        },
        {
          headerName: 'Excepted Quantities',
          field: 'exceptedQuantities',
          width: 100
        }
      ],
      gridApi: null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  methods: {
    saveHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectData'))
        return
      }
      this.$emit('onImdgCodeSelSucceed', rows[0])
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
